import type { FunctionComponent } from 'react'
import { MessagePage } from './MessagePage'

export const Error404Page: FunctionComponent = () => (
	<MessagePage title="Stránka nenalezena" returnLinkText="Přejít na úvodní stránku" />
)
